import { formatAllocationPennies } from './invoicePoAllocationHelpers'
import { getMultiPoAllocationSummary } from './invoiceMultiDocRules'

/**
 * Table / summary copy for invoices matched to multiple POs.
 */
export function getInvoiceMatchedOrdersTableDisplay(invoice = {}) {
  const multiPo = getMultiPoAllocationSummary(invoice)
  if (multiPo.isMultiPo) {
    const pos = multiPo.slices.map(slice => slice.purchaseOrderNumber)
    return {
      isMultiPo: true,
      count: multiPo.count,
      primary: pos[0] || '',
      extraCount: Math.max(0, pos.length - 1),
      label: `Matched orders (${multiPo.count})`,
      subtitle: multiPo.subtitle,
      purchaseOrderNumbers: pos,
      slices: multiPo.slices,
    }
  }

  const matched = Array.isArray(invoice.matchedPurchaseOrderNumbers)
    ? invoice.matchedPurchaseOrderNumbers
        .map(value => String(value || '').trim())
        .filter(Boolean)
    : []

  if (matched.length >= 2) {
    return {
      isMultiPo: true,
      count: matched.length,
      primary: matched[0],
      extraCount: matched.length - 1,
      label: `Matched orders (${matched.length})`,
      subtitle: matched.join(' · '),
      purchaseOrderNumbers: matched,
      slices: matched.map(po => ({ purchaseOrderNumber: po, label: po })),
    }
  }

  const primary =
    String(invoice.purchaseOrderNumber || '').trim() ||
    matched[0] ||
    String(invoice.matchSummary?.purchaseOrderNumber || '').trim()

  return {
    isMultiPo: false,
    count: primary ? 1 : 0,
    primary,
    extraCount: 0,
    label: primary ? 'Matched order' : '',
    subtitle: primary,
    purchaseOrderNumbers: primary ? [primary] : [],
    slices: primary ? [{ purchaseOrderNumber: primary, label: primary }] : [],
  }
}

export function formatMatchedOrderSliceLabel(slice = {}) {
  if (slice.label) return slice.label
  const po = String(slice.purchaseOrderNumber || '').trim()
  if (!po) return ''
  if (slice.amountPennies != null) {
    return `${po} · ${formatAllocationPennies(slice.amountPennies)}`
  }
  return po
}
